import React from 'react'
import { ProfileSettingsPageBusinessLogicProvider } from './context'

interface ComponentProps extends React.ComponentProps<any> {}

export const ProfileSettingsPageLogic: React.FunctionComponent<ComponentProps> = (props: ComponentProps) => {
  return <ProfileSettingsPageBusinessLogicProvider>{props.children}</ProfileSettingsPageBusinessLogicProvider>
}
